import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { useClientTranslation } from "hooks/useClientTranslation";
import { usePageTracking } from "hooks/usePageTracking";

export const InvalidSession = () => {
  usePageTracking({ name: "Error - view", properties: { type: "Session does not exist" } });
  const { t } = useClientTranslation();

  return (
    <PageLayout title={t("error.api_load.header")}>
      <Text sizeVariant="md" mt={24} mx={24}>
        {t("error.session_does_not_exist.instruction")}
      </Text>
      <Text sizeVariant="md" mt={8} mx={24}>
        {t("error.contact_us")}
      </Text>
    </PageLayout>
  );
};
